import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  SubDomesManagement,
} from '../../components';
import config from '../../config';
import './subdomesmanagement.global.scss';

interface Props {
  intl: any;
  scrollingDisabled: any;
}

const SubDomesManagementComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'SubDomesmanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <SubDomesManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const SubDomesManagementComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(SubDomesManagementComponent);

export default SubDomesManagementComponentPage;
